import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=6157cd9d&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=ts"
export * from "./user-profile.vue?vue&type=script&lang=ts"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=6157cd9d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157cd9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6157cd9d')) {
      api.createRecord('6157cd9d', component.options)
    } else {
      api.reload('6157cd9d', component.options)
    }
    module.hot.accept("./user-profile.vue?vue&type=template&id=6157cd9d&scoped=true", function () {
      api.rerender('6157cd9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/user-profile/user-profile.vue"
export default component.exports